
/**
 * @module PendingCall
 * @description
 */

var Model = require("../types/Model.js");

module.exports = Model({
	name: "pendingcall",
	init: init,
	listeners: listeners,

	getList: getList
});

function init() {
	this.getList();
}

function listeners() {
	return {
		"connectivity:online": getList
	};
}

function getList() {
	this.api.calls.pending()
		.then(handle_list.bind(this));
}

function handle_list(list) {
	if(list.length === 0) return;

	list.map(handle_item.bind(this));
}

function handle_item(data, index) {
	setTimeout(function() {
		var voiceCall = !!data.voiceOnly;
		var room = data._id;
		var from = data.from;
		var conference = Array.isArray(from) ? from[1] : null;

		if (conference) {
			this.emit("mqtt:$/call/conference", {
				room: room,
				participants: from,
				voiceOnly: voiceCall
			});
		} else {
			this.emit("mqtt:$/call", {
				from: from,
				room: room,
				voiceOnly: voiceCall
			});
		}
	}.bind(this), index * 1000);
}
